import React from "react";
import { useLanguage } from "@/context/LanguageContext";

export const Marquee = () => {
  const { t } = useLanguage();
  const items = t.marquee;

  return (
    <div className="relative z-10 bg-burgundy border-y border-gold/25 py-5 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex items-center">
            {items.map((item) => (
              <span key={`${copy}-${item}`} className="flex items-center">
                <span className="font-serif italic text-xl sm:text-2xl px-8 text-cream/90">{item}</span>
                <span className="text-gold text-xs">&#10022;</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
